module.exports = __webpack_public_path__ + "media/images/maps/pins/pin-02bcea3ea80f10e36fa143f56b78686f.png";